import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router';
import request from '../../../services/Request';
import LoadingIcon from '../../items/buttons/LoadingIcon';
import BackButton from '../../items/buttons/BackButton';
import { userLimits } from '../uitls/userLimits';
import EditAlphModal from './EditAlphModal';
import ModernTable, { ModernPageHeader } from '../components/ModernTable';
import { Box, Chip, alpha, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import PersonIcon from '@mui/icons-material/Person';
import EditIcon from '@mui/icons-material/Edit';

const getAllEmployeesURL = `/users/hf/getUsers`;
const deleteUserURL = `/users/delete/`;

export default function ViewAlphUser(props) {
  const theme = useTheme();
  const user = JSON.parse(localStorage.getItem('user'));
  const dbaUser = user.dba;
  const { id, tableTitle, superAdmin } = userLimits(
    props.match.params.id,
    props.match.params.group,
    'Users'
  );

  let history = useHistory();
  const [employees, setEmployees] = useState([]);
  const [reflesh, setReflesh] = useState(false);
  const [isloading, setIsLoading] = useState(false);
  const [show, setshow] = useState(false);
  const [rowdata, setrowdata] = useState(null);

  useEffect(() => {
    let isCancelled = false;

    //getAllEmployees
    async function getAllEmployees() {
      await request({
        method: 'post',
        url: getAllEmployeesURL,
        data: {
          referTo: id,
        },
      }).then((res) => {
        if (!isCancelled) {
          console.log('res.data', res.data);
          setEmployees(res.data);
          setIsLoading(true);
        }
      });
    }

    const getMyData = async () => {
      await request({
        method: 'get',
        url: `/users/getUserByEmail/${id}`,
      }).then((res) => {
        console.log('res.data', res.data);
        setrowdata(res.data);
      });
    };

    getMyData();
    getAllEmployees();

    return () => {
      isCancelled = true;
    };
  }, [reflesh, id]);

  const columns = [
    {
      title: 'Email',
      field: 'email',
      render: (rowData) => (
        <Typography
          variant="body2"
          sx={{
            color: theme.palette.text.secondary,
            fontFamily: 'monospace',
            fontSize: '0.875rem',
          }}
        >
          {rowData.email}
        </Typography>
      ),
    },
    {
      title: 'Credit',
      field: 'credit',
      render: (rowData) => (
        <Chip
          label={`$${rowData.credit || 0}`}
          sx={{
            fontWeight: 600,
            fontSize: '0.875rem',
            borderRadius: 2,
            height: 32,
            backgroundColor: alpha(theme.palette.success.main, 0.12),
            color: theme.palette.success.dark,
            border: `1.5px solid ${alpha(theme.palette.success.main, 0.3)}`,
          }}
        />
      ),
    },
    {
      title: 'Usage',
      width: '60%',
      render: (rowData) => (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
          {rowData?.categories?.map((cate, index) => (
            <Chip
              key={index}
              label={
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                  <Typography
                    component="span"
                    sx={{
                      fontWeight: 600,
                      fontSize: '0.875rem',
                    }}
                  >
                    {cate.category?.name?.en}
                  </Typography>
                  <Typography
                    component="span"
                    sx={{
                      color: theme.palette.primary.main,
                      fontWeight: 700,
                      fontSize: '0.875rem',
                    }}
                  >
                    : {cate.quantity}
                  </Typography>
                </Box>
              }
              sx={{
                height: 32,
                borderRadius: 2,
                backgroundColor: alpha(theme.palette.primary.main, 0.1),
                border: `1.5px solid ${alpha(theme.palette.primary.main, 0.3)}`,
                color: theme.palette.text.primary,
                '&:hover': {
                  backgroundColor: alpha(theme.palette.primary.main, 0.15),
                },
              }}
            />
          ))}
        </Box>
      ),
    },
  ];

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.02)} 0%, ${alpha(
          theme.palette.secondary.main,
          0.02
        )} 100%)`,
        p: { xs: 5, sm: 6, md: 7, lg: 8 },
      }}
    >
      {!isloading && <LoadingIcon />}

      {/* Header Section with Title */}
      <ModernPageHeader
        title={tableTitle || 'Alphasite Users'}
        subtitle="Manage Alphasite user accounts, credits, and category usage"
        icon={PersonIcon}
        buttonText="Edit Info"
        buttonIcon={EditIcon}
        onButtonClick={() => setshow(true)}
      />

      {/* Modern Table */}
      <ModernTable
        columns={columns}
        data={employees}
        localization={{ body: { editRow: { deleteText: 'Are you sure to delete this user' } } }}
        options={{
          actionsColumnIndex: -1,
          rowStyle: (rowData) => {
            if (rowData.dba) {
              return {
                backgroundColor: alpha(theme.palette.info.main, 0.05),
                borderLeft: `4px solid ${theme.palette.info.main}`,
              };
            }
          },
          pageSize: 10,
          pageSizeOptions: [10, 20, 50, 100],
        }}
      />

      {/* Back Button */}
      <Box sx={{ mt: 3 }}>
        <BackButton />
      </Box>

      {/* Edit Modal */}
      <EditAlphModal
        id={id}
        show={show}
        setshow={setshow}
        data={rowdata}
        user={user}
        setReflesh={setReflesh}
        reflesh={reflesh}
        onHide={() => setshow(false)}
      />
    </Box>
  );
}
